import React from 'react';

import { ProductImage } from 'src/components/product-image';

import type { PremiumBrandContentFragment } from 'src/types';
import * as S from './styles';

const FeaturedProducts = ({
  title,
  products,
}: {
  title: string;
  products: PremiumBrandContentFragment['featuredProducts'];
}) => {
  if (!products || products.length < 1) return null;

  return (
    <>
      <S.Header>{title}</S.Header>
      {products
        .filter(
          Boolean as unknown as (
            v: any
          ) => v is Exclude<typeof v, null | undefined>
        )
        .map(({ id, name, pathName, media, priceSummary, subtitle }) => (
          <S.Product
            key={id}
            link={pathName}
            name={name}
            image={media && <ProductImage name={name} src={media.first} />}
            price={priceSummary.regular || priceSummary.alternative}
            subtitle={subtitle}
          />
        ))}
    </>
  );
};

export default FeaturedProducts;
